import React from "react";
import "../assets/styles/LoadingSpinner.css"

const LoadingSpinner = () => {
  return <div className="loading-spinner"></div>;
};

export default LoadingSpinner;
